import { useState } from 'react';
import { Box, Collapse, styled } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';
import { ExpandButtonSimple } from '../../../common/ExpandButtonSimple';
import BetaTag from '../../../common/BetaTag';

const SectionBox = styled(Box)(() => ({
  padding: '0 0 16px 0',
  borderBottom: `1px solid ${colors.grey[120]}`,
  width: '100%',
}));

interface ServiceNowMigrationSectionProps {
  title: string;
  items?: string[];
  isExpandedByDefault?: boolean;
}

export const ServiceNowMigrationSection = ({
  title,
  items,
  isExpandedByDefault = false,
}: ServiceNowMigrationSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(isExpandedByDefault);

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <SectionBox>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        onClick={() => setIsExpanded(!isExpanded)}
        sx={{ cursor: 'pointer', width: '100%' }}
      >
        <Box display="flex" gap={1} alignItems="center" width="100%" pr={1}>
          <Typography variant="h5-medium">{title}</Typography> <BetaTag />
        </Box>
        <ExpandButtonSimple buttonSize="tiny" isExpanded={isExpanded} />
      </Box>
      <Collapse in={isExpanded}>
        <Box pt={2} display="flex" width="100%" flexDirection="column" gap={1}>
          {items.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1,
              }}
            >
              <Typography variant="body" color={colors.grey[700]}>
                •
              </Typography>
              <Typography variant="body" color={colors.grey[700]}>
                {item}
              </Typography>
            </Box>
          ))}
        </Box>
      </Collapse>
    </SectionBox>
  );
};
